import React from "react";
import CheckUpdateButton from "@/components/CheckUpdateButton";

/** All'avvio sull'app Android verifica OTA e apre il popup di download. */
export default function AutoAppUpdate() {
  return (
    <div className="sr-only" aria-hidden>
      <CheckUpdateButton auto className="!hidden" />
    </div>
  );
}
